interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  /** When true, content stays hidden (opacity 0) until ready flips to true/undefined */
  ready?: boolean;
}

/**
 * CSS-only fade-in transition. Replaces framer-motion to keep ~127 KB out of
 * the public bundle. Uses `opacity` + `transition` (composited, GPU-cheap).
 */
export default function PageTransition({ children, className, ready = true }: PageTransitionProps) {
  return (
    <div
      className={className}
      style={{
        opacity: ready ? 1 : 0,
        transition: 'opacity 0.3s ease-out',
        willChange: 'opacity',
      }}
    >
      {children}
    </div>
  );
}
